import { KEYWORD_CONSOLIDATION_MAP } from "../consts";

export const queryString = (urlQueryString = window.location.search) =>
  urlQueryString.substring(1);

export const urlToParams = (decoded = true) => {
  const s = queryString();

  const params = s.split("&").reduce((memo, param) => {
    const [k, v] = param.split("=");
    if (decoded) {
      memo[decodeURIComponent(k)] = urlArrayValues(
        memo[decodeURIComponent(k)],
        decodeURIComponent(v),
      );
    } else {
      memo[k] = urlArrayValues(memo[k], v);
    }
    return memo;
  }, {});

  return params;
};

/**
 * Handle array params e.g. search[child_category_ids][]=1
 */
export const urlArrayValues = (existingValue?: string, newValue?: string) => {
  if (existingValue) {
    return Array(existingValue).flat().concat(newValue);
  }
  return newValue;
};

export const parameterize = (str: string): string => {
  if (!str) return "";
  return str
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 -]/g, "-")
    .replace(/\s/g, "-")
    .replace(/^-/, "")
    .replace(/-$/, "");
};

/**
 * Consolidates search keywords to improve search results by combining related
 * business categories based on configured mappings.
 *
 * This function checks if the provided keyword exactly matches any key in the
 * KEYWORD_CONSOLIDATION_MAP. If a match is found, it returns the consolidated
 * term; otherwise, it returns the original keyword unchanged.
 *
 * @param sanitizedKeywords - Pre-sanitized lowercase keywords from user input
 * @returns Consolidated keywords or original if no mapping exists
 *
 * @example
 * consolidateKeywords('newsagency') // returns 'newsagency tatts'
 * consolidateKeywords('newsagency melbourne') // returns 'newsagency melbourne' (no match)
 * consolidateKeywords('cafe') // returns 'cafe' (no mapping defined)
 */
export const consolidateKeywords = (sanitizedKeywords: string): string => {
  if (!sanitizedKeywords) return "";

  const trimmed = sanitizedKeywords.trim().toLowerCase();

  // Check if there's a configured mapping for this exact keyword
  if (KEYWORD_CONSOLIDATION_MAP[trimmed]) {
    return KEYWORD_CONSOLIDATION_MAP[trimmed];
  }

  return sanitizedKeywords;
};
